import React, { useCallback } from 'react';
import { observer } from 'mobx-react';

import type Trip from '@this/src/domain/trip/trip2';
import { Fetcher } from '@this/src/util';
import { MemoForm } from './memo_form';

type Props = {
  className?: string;
  trip: Trip;
};

export const UserMemoField = observer(({ className, trip }: Props) => {
  const handleUserMemoSubmit = useCallback(
    async (memo: string) => {
      await Fetcher.post('/user_memos/update_or_create.json', { memo, user_id: trip.user.id });
    },
    [trip.user.id]
  );

  return (
    <div className={className}>
      <MemoForm
        inputName="user_memo"
        label="メモ"
        initialValue={trip.user.userMemos && trip.user.userMemos.length > 0 ? trip.user.userMemos[0].memo : ''}
        placeholder="例）禁煙席・朝食付き"
        onSubmit={handleUserMemoSubmit}
        testId="user-memo-form"
      />
    </div>
  );
});
